// Offer category odds are drawn before this within-category item weighting.
// Ability charge rules stay independent of how often an item is selected.
const ACTIVE_RELIC_SELECTION_WEIGHT = 2;
export const ACTIVE_RELIC_SHOP_PRICES = {
  phaseAnchor: 5,
  ghostBump: 6,
  chainReaction: 8,
  decoyBeacon: 8,
  lastStandProtocol: 12,
};

export const selectWeightedRelic = (pool, catalog, random = Math.random) => {
  if (!pool.length) return null;
  const weight = (id) =>
    catalog[id].activeAbility || id === 'mirrorChip'
      ? ACTIVE_RELIC_SELECTION_WEIGHT
      : 1;
  const total = pool.reduce((sum, id) => sum + weight(id), 0);
  let pick = Math.max(0, Math.min(0.999999999999, random())) * total;
  for (const id of pool) {
    pick -= weight(id);
    if (pick < 0) return id;
  }
  return pool[pool.length - 1];
};
